<template>
  <div>
    <div v-if="mode === 'DESIGN'">
      <div class="design">
        <i class="el-icon-plus"></i>
      </div>
      <p>{{ placeholder }} {{ sizeTip }}</p>
    </div>
    <div v-else>
      <el-upload
        :file-list="pics"
        name="file"
        :action="actionUrl"
        :limit="maxSize"
        :multiple="maxSize > 0"
        :data="uploadParams"
        :disabled="!disabled"
        list-type="picture-card"
        :auto-upload="true"
        :on-success="handleSuccess"
        :on-change="handleChange"
        :on-remove="handleRemove"
        :on-preview="handlePictureCardPreview"
        :before-upload="beforeUpload">
        <i slot="default" class="el-icon-plus"></i>
        <div slot="file" slot-scope="{file}" v-if="false">
          <img class="el-upload-list__item-thumbnail" :src="file.url" alt="">
          <span class="el-upload-list__item-actions">
            <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
              <i class="el-icon-zoom-in"></i>
            </span>
            <span v-if="!disabled" class="el-upload-list__item-delete" @click="handleDownload(file)">
              <i class="el-icon-download"></i>
            </span>
            <span v-if="!disabled" class="el-upload-list__item-delete" @click="handleRemove(file)">
              <i class="el-icon-delete"></i>
            </span>
          </span>
        </div>
        <div slot="tip" class="el-upload__tip">{{ placeholder }} {{ sizeTip }}</div>
      </el-upload>
      <el-dialog :visible.sync="dialogVisible">
        <img width="50%" :src="dialogImageUrl" alt="">
      </el-dialog>
      <a-upload
        v-if="false"
        name="file"
        accept="image/png, image/jpeg, image/jpg"
        :action="actionUrl"
        list-type="picture-card"
        :file-list="picList"
        :data="uploadParams"
        :before-upload="beforeUpload"
        @preview="handlePictureCardPreview"
        @change="handleGoodsGalleryChange"
      >
        <div v-if="picList.length < maxSize">
          <a-icon type="plus" />
          <div class="ant-upload-text">
            上传
          </div>
        </div>
      </a-upload>
    </div>
  </div>
</template>

<script>
import componentMinxins from '../ComponentMinxins'
import { oss_token_list } from '@/api/oss_token'

export default {
  mixins: [componentMinxins],
  name: 'ImageUpload',
  components: {},
  props: {
    value: {
      type: Array,
      default: () => {
        return []
      }
    },
    placeholder: {
      type: String,
      default: '请选择图片'
    },
    maxSize: {
      type: Number,
      default: 5
    },
    maxNumber: {
      type: Number,
      default: 10
    },
    enableZip: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    sizeTip () {
      return this.maxSize > 0 ? `| 每张图不超过${this.maxSize}MB` : ''
    }
  },
  data () {
    return {
      disabled: false,
      dialogVisible: false,
      dialogImageUrl: '',
      actionUrl: '',
      picList: [],
      pics: [],
      uploadParams: {
        'key': '',
        'policy': '',
        'OSSAccessKeyId': '',
        'signature': ''
      }
    }
  },
  mounted () {
    if (this.mode !== 'DESIGN') {
      oss_token_list().then(({ data }) => {
        this.uploadParams.OSSAccessKeyId = data.accessid
        this.uploadParams.policy = data.policy
        this.uploadParams.signature = data.signature
        this.actionUrl = 'https://static2.jnzbtz.com'
      })
      this.pics.push(...this.value)
    }
  },
  methods: {
    beforeUpload (file) {
      const alows = ['image/jpeg', 'image/png', 'image/gif', 'image/jpg']
      if (alows.indexOf(file.type) === -1) {
        this.$message.warning('存在不支持的图片格式')
      } else if (this.maxSize > 0 && file.size / 1024 / 1024 > this.maxSize) {
        this.$message.warning(`单张图片最大不超过 ${this.maxSize}MB`)
      } else {
        const name = file.name
        const suffix = name.substring(name.lastIndexOf('.') + 1)
        const lastName = file.lastModified + '.' + suffix
        this.uploadParams.key = file.uid + '_' + lastName
        return true
      }
      return false
    },
    handleSuccess (response, file, fileList) {
    },
    handleChange (file, fileList) {
      this._value = fileList.map(item => {
        const name = item.name
        const suffix = name.substring(name.lastIndexOf('.') + 1)
        const lastName = item.raw.lastModified + '.' + suffix
        const newItem = this.actionUrl + '/' + item.raw.uid + '_' + lastName
        return newItem
      })
    },
    handleRemove (file, fileList) {
      console.log('删除', file, fileList)
    },
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    handleDownload (file) {
      console.log(file)
    }
  }
}
</script>

<style lang="less" scoped>
.design {
  i {
    padding: 10px;
    font-size: xx-large;
    background: white;
    border: 1px dashed #8c8c8c;
  }
}
/deep/ .el-upload--picture-card{
  width: 80px;
  height: 80px;
  line-height: 87px;
}
/deep/ .el-upload-list__item{
  width: 80px;
  height: 80px;
  .el-upload-list__item-actions{
    &> span+span{
      margin: 1px;
    }
  }
}
</style>
